export const data = ["127,147,188,199,100","271,472,170,299,150","172,247,710,239,350","721,274,290,259,510","712,742,970,929,190"]
